module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"select":"Выбрать"}}')
  delete Component.options._Ctor
}
